export function DashboardNotificationCtrl ($scope, $uibModalInstance, workshopAPI, notification) {

  // Break object reference to avoid affecting notifications grid.
  $scope.notification = notification ? angular.copy(notification) : {};

  if ($scope.notification.expires_on) {
    $scope.notification.expires_on = notification.expires_on.split('T')[0];
    $scope.notification.expires_on = moment(notification.expires_on).utc().format('YYYY-MM-D');
  }

  $scope.submit = function () {
    var parent = $scope.notification.id ? '' : 'system_notification';
    var method = $scope.notification.id ? 'patch' : 'post';

    if ($scope.notification.expires_on) {
      $scope.notification.expires_on = moment($scope.notification.expires_on).format('DD-MM-YYYY');
    }

    workshopAPI[method]('/system_notifications', $scope.notification, parent).then(function(data) {
      $uibModalInstance.close();
    }, function (err) {
      $uibModalInstance.dismiss(err);
    });
  };
}